<template>
  <div class="h-auto ml-0 w-full lg:mr-3">
    <div class="flex justify-start divide-x-1.5 mb-2 items-center" style="background-color: #eee; opacity: 1;">
      <button v-for="(tab, index) in tabs" :key="index" :class="{
        'bg-primary text-white': selectedTab == tab.name,
      }" class="text-sm text-center hover:bg-primary hover:text-white cursor-pointer p-3 w-32"
        @click="(e) => setTab(e, tab.name)">
        {{ tab.name }}
      </button>
    </div>
  </div>
</template>

<script>


export default {
  name: "LicenceTabs",
  props: ["updateLicenceList"],
  components: {

  },
  data() {
    return {
      selectedTab: "Active",
      teamKey: 0,
      mineKey: 1,
      isActive: true,
      isExpired: false,
      tabs: [
        {
          name: "Active",
          route: "mine",
        },
        {
          name: "Expired",
          route: "team",
        },
      ],
    };
  },
  created() {
    this.updateLicenceList(this.selectedTab)
  },
  methods: {
    close() {
      this.$emit("close");
    },

    setTab(event, newTab) {
      this.selectedTab = newTab.trim()
      this.updateLicenceList(this.selectedTab)

      switch (newTab) {
        case "Expired":

          break;
        case "Active":

          break;
      }
    },
  },

};
</script>
